<template>
    <AccountSettingsShell @buttonClick="updateNotifications">
        <CardShell>

            <!-- heading -->
            <BackLinkHeading linkText="Account Settings" text="Notifications" route="/settings-mobile"/>

            <HugeSpinner v-if="loadingUserNotifications"/>
            <div v-else>
                <div class="pt3 pb2 ph3 ph4-ns bb b--light-gray">

                    <!-- page description -->
                    <h6>Tooliaba notifications settings allow you to control what notifications get delivered to you.</h6>

                    <!-- communication methods -->
                    <div class="mt3 flex justify-end">
                        <h6>Text Message</h6>
                        <h6 class="w2 w3-ns ml3 ml4-ns tr">Email</h6>
                    </div>
        
                </div>

                <!-- notification options -->
                <NotificationOption
                    title="New Messages"
                    description="New messages from Tooliaba and renters waiting for you in your inbox"
                    :notifications="userNotifications[0]"
                />
                <NotificationOption
                    title="Newsletter & Promos"
                    description="Be the first to hear about upcoming news, important updates and exclusive promos."
                    :notifications="userNotifications[1]"
                />
                <NotificationOption
                    title="Account Related"
                    description="Strictly service related announcements on rare occasions when it is necessary to do so."
                    :notifications="userNotifications[2]"
                />
            </div>

        </CardShell>
    </AccountSettingsShell>
</template>

<script>
import AccountSettingsShell from '@/components/accountSettings/shared/AccountSettingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import NotificationOption from '@/components/accountSettings/notificationsCard/NotificationOption.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        AccountSettingsShell,
        CardShell,
        BackLinkHeading,
        HugeSpinner,
        NotificationOption
    },
    computed: {
        ...mapState('userNotifications', [
            'userNotifications',
            'loadingUserNotifications'
        ])
    },
    methods: {
        ...mapActions('userNotifications', [
            'getUserNotifications',
            'postLNotificationSettings'
        ]),
        updateNotifications() {
            this.postLNotificationSettings();
            this.$router.go();
        }
    },
    created: function() {
        this.getUserNotifications();
    }
};
</script>
